<div class="message">
You will need a valid subscription to continue. <br/>
Please contact your NetSuite administrator
</div>

<div class = "re-login"> 
If you already have a valid subscription, <br/>
<span class="click-here" onclick="logout()">click here</span> to re-login
</div>
